import React from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../../FaIcon';

/**
 * El triángulo de un bloque que muestra métricas de eventos cuando hay cuentas del informe sin
 * eventos elegidos (card UvIR4eHe, capa 2). Pablo: «tal cual como pasa en el tablero de control».
 *
 * Es el marcado de `DashboardCell.renderWarningIfNecessary()` —`.warning-icon-container` +
 * `.warning-tooltip`, estilos de `_tooltips.scss`— con dos diferencias a propósito: el texto va
 * por i18n (allá está escrito a mano), y la acción abre el modal de eventos en vez de mandar a la
 * solapa Cuentas de una línea, que acá no existe.
 *
 * Se alcanza con teclado: el contenedor toma foco y el tooltip también se abre con `:focus-within`
 * (`_informes.scss`). Sólo hover dejaba el botón fuera de alcance de quien navega con Tab.
 *
 * `opensTo` decide hacia dónde se despliega el cartel. Pegado a un título que arranca a la
 * izquierda abre hacia la derecha (`-below-left`, anclado al borde izquierdo del ⚠); en la KPI, donde
 * el ⚠ queda en el extremo derecho del renglón, abre hacia la izquierda (`-below-right`): hacia la
 * derecha, la última KPI de la fila lo sacaba de la grilla.
 */
export function PanelEventsWarning({onConfigure, opensTo = 'right'}) {
    const {t} = useTranslation();
    return (
        <div className="warning-icon-container inf-events-warning" tabIndex={0}
             aria-label={t('informes.events.panel.text')} data-testid="inf-events-warning">
            <FaIcon iconName="exclamation-triangle"/>
            <div className={`warning-tooltip ${opensTo === 'left' ? '-below-right' : '-below-left'}`}>
                <div className="warning-tooltip-body">
                    <p className="warning-tooltip-text">
                        {t('informes.events.panel.text')}{' '}
                        <button type="button" className="inf-events-warning__action" onClick={onConfigure}>
                            {t('informes.events.panel.cta')}
                        </button>
                    </p>
                </div>
            </div>
        </div>
    );
}
